var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAddImage = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Linear/galleryadd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 10.0293C9.53043 10.0293 10.0391 9.81858 10.4142 9.44351C10.7893 9.06844 11 8.55973 11 8.0293C11 7.49886 10.7893 6.99016 10.4142 6.61508C10.0391 6.24001 9.53043 6.0293 9 6.0293C8.46957 6.0293 7.96086 6.24001 7.58579 6.61508C7.21071 6.99016 7 7.49886 7 8.0293C7 8.55973 7.21071 9.06844 7.58579 9.44351C7.96086 9.81858 8.46957 10.0293 9 10.0293Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 2.0293H9C4 2.0293 2 4.0293 2 9.0293V15.0293C2 20.0293 4 22.0293 9 22.0293H15C20 22.0293 22 20.0293 22 15.0293V10.0293",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.75 5.0293H21.25M18.5 7.7793V2.2793",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M2.66992 18.9794L7.59992 15.6694C8.38992 15.1394 9.52992 15.1994 10.2399 15.8094L10.5699 16.0994C11.3499 16.7694 12.6099 16.7694 13.3899 16.0994L17.5499 12.5294C18.3299 11.8594 19.5899 11.8594 20.3699 12.5294L21.9999 13.9294",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAddImage, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/add_image.2b57522b.svg";
export { ForwardRef as ReactComponent };